import { Breadcrumb, ImportDataForm, PageHero } from "@";

// Page for importing data from an Excel file.
export default function Index() {
  const links = [{ name: "استيراد البيانات", link: "" }];

  return (
    <>
      <Breadcrumb links={links} />

      <main className="table-card relative pb-5">
        <PageHero eyebrow="الإعدادات / الاستيراد" title="استيراد البيانات" />

        {/* Form */}
        <div className="mt-8">
          <ImportDataForm />
        </div>
      </main>
    </>
  );
}
